import { useContext, useEffect, useRef, useState } from 'react'

import { Button, Text, theme } from '@hhgtech/hhg-components'
import { Badge, Carousel } from '@hhgtech/hhg-components/mantine'
import { Embla } from '@mantine/carousel'

import { getHelloSitesUrl } from 'api/utils/paths'
import { redirectToSSOWithReturnUrl } from 'api/utils/redirects'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { TogetherTopic } from 'interfaces/types'
import { AppContext } from 'state/appContext'

import { EmotionBadge, StyledCarousel } from './index.styled'

export const TopicScrollList = ({
  topics: _topics,
  communitySlug,
}: {
  topics?: Array<TogetherTopic>
  communitySlug?: string
}) => {
  const isMobile = useIsMobile()
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)
  const { locale } = useRouterExtend()
  // const { formatMessage: f } = useIntl()
  const [embla, setEmbla] = useState<Embla | null>(null)
  const shouldAllowClickRef = useRef(true)

  useEffect(() => {
    const handleScroll = () => {
      shouldAllowClickRef.current = false
    }

    const handlePointerUp = () => {
      setTimeout(() => {
        shouldAllowClickRef.current = true
      }, 1000)
    }
    if (embla) {
      embla.on('scroll', handleScroll)
      embla.on('pointerUp', handlePointerUp)
    }
    return () => {
      if (embla) {
        embla.off('scroll', handleScroll)
        embla.off('pointerUp', handlePointerUp)
      }
    }
  }, [embla])

  if (!_topics) return <></>
  // const showMoreOption = _topics.length > 3 && !isMobile
  const topics = _topics
  // _topics.length <= 3 ? _topics : isMobile ? _topics : _topics.slice(0, 3)

  const onTopicClick = (topic: TogetherTopic) => {
    if (!shouldAllowClickRef.current) return
    if (!isLoggedIn) {
      redirectToSSOWithReturnUrl(
        `${getHelloSitesUrl(
          locale,
        )}/community/on-boarding/?returnUrl=/${communitySlug}/${topic?.slug}`,
        'communities',
        'embeddedarticle',
        `${communitySlug}/${topic?.slug}`,
      )
    } else {
      window.location.href = `${getHelloSitesUrl(
        locale,
      )}/community/${communitySlug}/${topic?.slug}`
    }
  }
  // const onMoreClick = () => {
  //   if (!isLoggedIn) {
  //     redirectToSSOWithReturnUrl(
  //       `${getHelloSitesUrl(
  //         locale,
  //       )}/community/on-boarding/?returnUrl=/${communitySlug}/`,
  //       'communities',
  //       'embeddedarticle',
  //       `${communitySlug}/`,
  //     )
  //   } else {
  //     window.location.href = `${getHelloSitesUrl(
  //       locale,
  //     )}/community/${communitySlug}`
  //   }
  // }

  // return (
  //   <StyledScrollArea type="hover" offsetScrollbars scrollbarSize={2}>
  //     <div style={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
  //       {topics.map((topic) => (
  //         <Badge key={topic.id} color="#ffffff" styles={EmotionBadge}>
  //           <Button
  //             color="transparent"
  //             size="sm"
  //             onClick={() => onTopicClick(topic)}
  //             data-event-category="Together"
  //             data-event-action="Join Topic"
  //             data-event-label={`${getHelloSitesUrl(
  //               locale,
  //             )}/community/on-boarding/?returnUrl=/${communitySlug}/${
  //               topic?.slug
  //             }`}
  //             className="pointer-event-child-none"
  //           >
  //             <Text size="p3" color={theme.colors.gray600}>
  //               {topic.name}
  //             </Text>
  //           </Button>
  //         </Badge>
  //       ))}
  //       {showMoreOption && (
  //         <Badge color="#ffffff" styles={EmotionBadge}>
  //           <Button
  //             color="transparent"
  //             size="sm"
  //             onClick={onMoreClick}
  //             data-event-category="Together"
  //             data-event-action="Other Topic Click"
  //             data-event-label={`${getHelloSitesUrl(
  //               locale,
  //             )}/community/${communitySlug}`}
  //             className="pointer-event-child-none"
  //           >
  //             <Text size="p3" color={theme.colors.primaryBase} type="semiBold">
  //               {f({
  //                 id: 'embeddedCommunity.moreForums',
  //                 defaultMessage: 'More forums',
  //               })}
  //             </Text>
  //           </Button>
  //         </Badge>
  //       )}
  //     </div>
  //   </StyledScrollArea>
  // )
  return (
    <>
      {topics && topics.length > 0 && (
        <StyledCarousel
          align="start"
          slideGap="md"
          dragFree
          // withControls={false}
          slideSize="10%"
          styles={{
            root: {
              width: !isMobile ? '400px' : '100%',
            },
          }}
          getEmblaApi={setEmbla}
          // withControls={false}
          controlsOffset={-52}
        >
          {topics.map((topic) => (
            <Carousel.Slide key={topic.id}>
              <Badge color="#ffffff" styles={EmotionBadge}>
                <Button
                  color="transparent"
                  size="sm"
                  onClick={() => onTopicClick(topic)}
                  data-event-category="Together"
                  data-event-action="Join Topic"
                  data-event-label={`${getHelloSitesUrl(
                    locale,
                  )}/community/${communitySlug}/${topic?.slug}`}
                  className="pointer-event-child-none"
                >
                  <Text size="p4" color={theme.colors.gray600}>
                    {topic.name}
                  </Text>
                </Button>
              </Badge>
            </Carousel.Slide>
          ))}
          {/* {showMoreOption && (
        <Carousel.Slide>
        <Badge color="#ffffff" styles={EmotionBadge}>
        <Button
        color="transparent"
        size="sm"
        onClick={onMoreClick}
        data-event-category="Together"
        data-event-action="Other Topic Click"
        data-event-label={`${getHelloSitesUrl(
          locale,
          )}/community/${communitySlug}`}
          className="pointer-event-child-none"
          >
          <Text size="p4" color={theme.colors.primaryBase} type="semiBold">
          {f({
            id: 'embeddedCommunity.moreForums',
            defaultMessage: 'More forums',
          })}
          </Text>
          </Button>
          </Badge>
          </Carousel.Slide>
        )} */}
        </StyledCarousel>
      )}
    </>
  )
}
